// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3_plp","loader":"App_loader__groK5"};